module.exports = __webpack_public_path__ + "img/files-menu.c98b2f59.svg";